import ReducerRegistry from '../base/redux/ReducerRegistry';
import { SET_CHAT_HISTORY_VISIBLE, SET_CHAT_HISTORY_DATA, SET_SELECTED_CONVERSATION, SET_CONVERSATIONS_LIST, SET_CHAT_HISTORY_POLLING, SET_CHAT_HISTORY_LOADING, SET_CHAT_HISTORY_ERROR, ADD_CHAT_HISTORY_MESSAGES, SET_CHAT_HISTORY_LAST_UPDATED, STT_UPSERT_INTERIM, STT_COMMIT_FINAL, STT_CLEAR_TRANSCRIPTS, AI_RESPONSE_APPEND, AI_RESPONSE_FINAL } from './actionTypes';
const DEFAULT_STATE = {
    visible: false,
    messages: [],
    selectedConversationId: null,
    conversations: [],
    polling: false,
    loading: false,
    error: null,
    lastUpdated: null,
    transcripts: [],
    interims: {},
    aiInterims: {}
};
/**
 * Reduces the Redux actions of the feature chat history.
 */
ReducerRegistry.register('features/chat_history', (state = DEFAULT_STATE, action) => {
    switch (action.type) {
        case SET_CHAT_HISTORY_VISIBLE:
            return {
                ...state,
                visible: action.visible
            };
        case SET_CHAT_HISTORY_DATA:
            return {
                ...state,
                messages: action.data
            };
        case SET_SELECTED_CONVERSATION:
            return {
                ...state,
                selectedConversationId: action.conversationId
            };
        case SET_CONVERSATIONS_LIST:
            return {
                ...state,
                conversations: action.conversations
            };
        case SET_CHAT_HISTORY_POLLING:
            return {
                ...state,
                polling: action.polling
            };
        case SET_CHAT_HISTORY_LOADING:
            return {
                ...state,
                loading: action.loading
            };
        case SET_CHAT_HISTORY_ERROR:
            return {
                ...state,
                error: action.error
            };
        case ADD_CHAT_HISTORY_MESSAGES:
            const newMessages = [...state.messages];
            action.messages.forEach((msg) => {
                if (!newMessages.find(m => m.id === msg.id)) {
                    newMessages.push(msg);
                }
            });
            return {
                ...state,
                messages: newMessages.sort((a, b) => new Date(a.timestamp).getTime() - new Date(b.timestamp).getTime())
            };
        case SET_CHAT_HISTORY_LAST_UPDATED:
            return {
                ...state,
                lastUpdated: action.timestamp
            };
        case STT_UPSERT_INTERIM:
            // Overwrite this participant's in-progress line (never append).
            return {
                ...state,
                interims: {
                    ...state.interims,
                    [action.line.participantId]: action.line
                }
            };
        case STT_COMMIT_FINAL: {
            // Append the confirmed line and drop that participant's interim.
            const interims = { ...state.interims };
            delete interims[action.line.participantId];
            return {
                ...state,
                transcripts: [...state.transcripts, action.line],
                interims
            };
        }
        case STT_CLEAR_TRANSCRIPTS:
            return {
                ...state,
                transcripts: [],
                interims: {},
                aiInterims: {}
            };
        case AI_RESPONSE_APPEND: {
            // Concatenate streaming chunks keyed by generation_id.
            const prev = state.aiInterims[action.generationId];
            return {
                ...state,
                aiInterims: {
                    ...state.aiInterims,
                    [action.generationId]: {
                        id: `ai-int-${action.generationId}`,
                        participantId: action.participantId,
                        name: 'AI',
                        text: (prev?.text ?? '') + action.chunk,
                        final: false,
                        isAi: true,
                        ts: prev?.ts ?? action.ts
                    }
                }
            };
        }
        case AI_RESPONSE_FINAL: {
            // Replace the streaming line with the full text and append to the log.
            const aiInterims = { ...state.aiInterims };
            delete aiInterims[action.generationId];
            return {
                ...state,
                transcripts: [...state.transcripts, {
                        id: `ai-${action.generationId}`,
                        participantId: action.participantId,
                        name: 'AI',
                        text: action.text,
                        final: true,
                        isAi: true,
                        ts: action.ts
                    }],
                aiInterims
            };
        }
        default:
            return state;
    }
});
